const cohorts = [
  "WEBEU1",
  "WEBEU2",
  "WEBEU3",
]

export default cohorts;